import { css } from "@emotion/react";
import styled from "@emotion/styled";

import transition from "~/utilities/transition";
import { isBoolean } from "lodash";

export const screenReaderText = css`
    border: 0;
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    word-wrap: normal !important;
`;

export const ScreenReaderText = styled.span`
    ${screenReaderText};
`;

export const baseTextDecorationCss = css`
    ${transition({}, "all")};
    text-underline-offset: 5px;
    padding-bottom: 5px;
    text-decoration: underline solid transparent;
`;

export const hoverTextDecorationCss = css`
    text-decoration-color: currentColor;
`;

export const getTextDecorationStyles = ({
    showtextdecoration,
    targetelement,
}) => {
    const showTextDecoration = isBoolean(showtextdecoration)
        ? showtextdecoration
        : showtextdecoration === "true";

    if (showTextDecoration && targetelement) {
        return css`
            & > ${targetelement} {
                ${baseTextDecorationCss};
            }

            &:hover > ${targetelement}, &:focus > ${targetelement} {
                ${hoverTextDecorationCss};
            }
        `;
    }

    if (showTextDecoration) {
        return css`
            ${baseTextDecorationCss};

            &:hover,
            &:focus {
                ${hoverTextDecorationCss};
            }
        `;
    }

    return css`
        text-decoration: inherit;
    `;
};
